/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormElementBase } from '../models/FormElementBase';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FormElementService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all elements of a form.
     * @param formDefinitionGuid The form's guid.
     * @returns FormElementBase OK
     * @throws ApiError
     */
    public getAllFormElements(
        formDefinitionGuid: string,
    ): CancelablePromise<Array<FormElementBase>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/mwforms/{formDefinitionGuid}/elements',
            path: {
                'formDefinitionGuid': formDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new form element.
     * @param formDefinitionGuid
     * @param requestBody The form element to create
     * @returns FormElementBase OK
     * @throws ApiError
     */
    public createFormElement(
        formDefinitionGuid: string,
        requestBody?: FormElementBase,
    ): CancelablePromise<FormElementBase> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/mwforms/{formDefinitionGuid}/elements',
            path: {
                'formDefinitionGuid': formDefinitionGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a single form element by its guid.
     * @param formDefinitionGuid The form's guid.
     * @param elementGuid The elements guid.
     * @returns FormElementBase OK
     * @throws ApiError
     */
    public getFormElement(
        formDefinitionGuid: string,
        elementGuid: string,
    ): CancelablePromise<FormElementBase> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/mwforms/{formDefinitionGuid}/elements/{elementGuid}',
            path: {
                'formDefinitionGuid': formDefinitionGuid,
                'elementGuid': elementGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update a form element by its Guid.
     * @param formDefinitionGuid
     * @param elementGuid The elements guid.
     * @param requestBody The updated form element
     * @returns FormElementBase OK
     * @throws ApiError
     */
    public updateFormElement(
        formDefinitionGuid: string,
        elementGuid: string,
        requestBody?: FormElementBase,
    ): CancelablePromise<FormElementBase> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/mwforms/{formDefinitionGuid}/elements/{elementGuid}',
            path: {
                'formDefinitionGuid': formDefinitionGuid,
                'elementGuid': elementGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete a form element
     * @param formElementGuid
     * @param formDefinitionGuid
     * @returns FormElementBase OK
     * @throws ApiError
     */
    public deleteFormElement(
        formElementGuid: string,
        formDefinitionGuid: string,
    ): CancelablePromise<FormElementBase> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/mwforms/{formDefinitionGuid}/elements/{formElementGuid}/DeleteFormElement',
            path: {
                'formElementGuid': formElementGuid,
                'formDefinitionGuid': formDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
